module.exports = __webpack_public_path__ + "static/img/banner_solutions_key.9d0d41b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/solution/banner_solutions_key.png
// module id = j/wQ
// module chunks = 10